import capitalize from 'lodash/capitalize'
import Color from 'color'

import { colorable } from '../utils/color'
import theme from '../utils/theme'

// Palette meta information
const meta = {
  purple: {
    base: 600,
    meta: {
      900: {
        name: 'Brand Darker',
      },
      700: { name: 'Brand Dark' },
      600: {
        name: 'Gatsby',
        pms: {
          value: '2077 C',
          href: 'https://www.pantone.com/color-finder/2077-C',
        },
        cmyk: {
          value: '76 85 0 0',
        },
      },
      500: { name: 'Lilac' },
      200: { name: 'UI Bright' },
      100: { name: 'UI Light' },
      50: { name: 'UI Whisper' },
    },
  },
  orange: {
    base: 500,
    meta: {
      500: { name: 'Mustard' },
    },
  },
  magenta: { base: 500 },
  red: {
    base: 500,
    meta: {
      400: { name: 'Warning' },
    },
  },
  green: {
    base: 500,
    meta: {
      500: { name: 'Success' },
    },
  },
  yellow: {
    base: 400,
    meta: {
      400: { name: 'Lemon' },
    },
  },
  blue: {
    base: 500,
  },
  black: {
    base: 900,
    meta: {
      900: {
        name: 'Black',
        cmyk: {
          value: '0 0 0 100',
        },
      },
    },
  },
  white: {
    base: 900,
    meta: {
      900: {
        name: 'White',
        cmyk: {
          value: '0 0 0 0',
        },
      },
    },
  },
  grey: {
    base: 400,
  },
  teal: {
    base: 500,
  },
}

// To merge info from
// - meta
// - theme.colors
// - contrast and accessibility information
// let's do some noob stuff!
let palette = []

for (var color in theme.colors) {
  let m = meta[color]
  let c = {}

  Object.keys(theme.colors[color])
    .sort((a, b) => a - b)
    .forEach(foo => {
      c[foo] = {
        hex: theme.colors[color][foo],
        // Contrast and a11y info
        ...colorable(theme.colors[color][foo]),
        // Is base color? (lol)
        ...(m && m.base && m.base === foo && { base: true }),
        // Is named? (moar lol)
        ...(m && m.meta && m.meta[foo] && { name: m.meta[foo].name }),
        // PMS? (...)
        ...(m && m.meta && m.meta[foo] && { pms: m.meta[foo].pms }),
        // Moar meta? (...)
        ...(m && m.meta && m.meta[foo] && { cmyk: m.meta[foo].cmyk }),
        rgb: Color(theme.colors[color][foo])
          .rgb()
          .object(),
      }
    })

  palette[color] = {
    // Color group name
    name: capitalize(color),
    // Base color index
    ...(m && m.base && m.base ? { base: m.base } : {}),
    colors: c,
  }
}

export default palette
